import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DistributionChannelList.html?raw';

import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { StringHelpers } from "../../../more/Helpers";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';

class DistributionChannelList extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private btnReload: HTMLElement;
    private btnNew: HTMLElement;
    private tableContainer: HTMLDivElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.DistributionChannels>>>;

    private crud: VAM2types.CrudPrivilages = null;

    private sedFilterAttributes: any = {
        ref_ev_room: null,
        date_start: null
    };

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.hideNode(this.btnReload, !this.entityId);

        let data = this.getAttributeValue("distributionChannels");
        if (this.getAttributeValue("distributionChannelsDiffData") == null) this.store.setup(data);

        this.sedFilterAttributes.ref_ev_room = this.getAttributeValue("ref_ev_room");
        this.sedFilterAttributes.date_start = this.getAttributeValue("date_start");
    }

    private _onStoreChange(e) {
        let diffData = lang.clone(this.store.getDiffData());

        this.setAttributeValue("distributionChannelsDiffData", diffData);
    }

    private _onClickReload() {
        this._reload();
    }
    private _reload(): void {

        this.StandbyStart();
        let entityID = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        let data = { bookingID: entityID, classname: classname };

        this.RequestManager.callfunction("Webtool_API_EvBooking__DistributionChannels_GetListData",
            data,
            lang.hitch(this, this._onReloadResponse),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            });
    }

    private _onReloadResponse(response: Array<VAM2types.DistributionChannels>): void {
        this.StandbyStop();
        this.store.setup(response);
        this.updateTable();
        this.emit("reloaded");
    }
    private _setupTable(response: { layouts: Array<any> }) {
        if (this.table != null) this.table.destroy();

        this.table = new StaticTable();
        this.table.placeAt(this.tableContainer);

        this.table.setLayout(response.layouts[0]);
        if (this.crud.hasRead) {
            this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
            this.table.addDefaultRowActionButton("view", lang.hitch(this, this._onClick_ViewBtn))
        }

        if (this.crud.hasDelete) this.table.addDefaultRowActionButton("delete");

        this.table.setCyAttribute("distributionChannelList");

        this.updateTable();
    }

    private updateTable() {

        this.table.setupFromStore(this.store);
    }

    private _onClick_ViewBtn(rowGroup: StaticTable.StaticTableRowGroup<VAM2types.DistributionChannels>) {

        this.showEntityView(rowGroup.entity.channelID)
    }

    private _onTableRowClick(row: StaticTable.StaticTableRow<VAM2types.DistributionChannels>, rowGroup: StaticTable.StaticTableRowGroup<VAM2types.DistributionChannels>, evt: Event) {

        this.showEntityView(rowGroup.entity.channelID)
    }
    private showEntityView(entityID: string) {

        let entityView = new GenericEntityView();

        entityView.setup(entityID, VAMclassNames.ev_distribution_channel, "", "", "dlg");

    }

    hasData(): boolean {
        let completeList = this.store.getCurrentCompleteList();
        let deleteList = this.store.getCurrentCompleteList("deleted");
        let response = false;

        if (deleteList.length > 0) completeList.forEach(e => { if (deleteList.indexOf(e) == -1) response = true; });
        else response = completeList.length > 0;

        return response;
    }

    disableEdit(disable: boolean = true) {

        this.disableNode(this.btnNew, disable);
        this.table?.enableActionButton("delete", null, !disable);
    }

    updateSedFilterValues(attr: string, newValue: any) {

        this.sedFilterAttributes[attr] = newValue;
    }

    private _onClickAdd(evt) {
        if (this.crud.hasCreate !== true) return;

        this.loadSelectEntityDialog(evt,
            "selectDistributionChannels",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            this.sedFilterAttributes
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<VAM2types.Entity_description>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;
        if (mode == "selectDistributionChannels") {
            for (let item of items) {

                let entity: Partial<VAM2types.Entity_description> = item.entry?.data;

                if (!entity) {
                    entity = {
                        ID: item.entry.value, description: item.entry.label
                    };
                }
                else {
                    
                }

                this.addNewEntry(entity as any);
            }
        }
    }
    private addNewEntry(value: VAM2types.Entity_description) {
        if (value != null) {

            let fakeChannel: Partial<VAM2types.DistributionChannels> = {
                ID: StringHelpers.randomID(16),
                channelID: value.ID,
                description: value.code,
                ref_ev_distribution_channel: value
            }

            if (this.store.isEntityExisting(fakeChannel as any, "channelID", true)) {
                this.showToast({
                    title: this.translate(`DistributionChannelList_Toast_ExistInList`),
                    message: `**${value.description}**  ${this.translate(`DistributionChannelList_Toast_ExistInList_details`)}`,
                    messageIcon: "fas fa-info-circle",
                    iconClass: "fas fa-info-circle"
                });
            }
            else {
                this.store.addEntry(fakeChannel as any, "new");
            }
        }
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (!this.hasFeature("EvBooking/DistributionChannels") || !this.hasUserRole("EvBooking_DistributionChannels")) {
            return;
        }

        this.store = new EntityStore
        this.store.on("change", lang.hitch(this, this._onStoreChange));
        
        this.RequestManager.callfunction(
            "Webtool_API_EvBooking__DistributionChannels_GetDistributionChannelTableLayout",
            null,
            lang.hitch(this, this._setupTable),
            (err) => {
                if (this.hasFeature("EvBooking/DistributionChannels") && this.hasUserRole("EvBooking_DistributionChannels")) {

                    this.showToast(err.Message);
                }
            }
        )

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        this.crud = {
            hasRead: this.hasUserRole("EvBooking_DistributionChannels_Read"),
            hasEdit: this.hasUserRole("EvBooking_DistributionChannels_Edit"),
            hasCreate: this.hasUserRole("EvBooking_DistributionChannels_Create"),
            hasDelete: this.hasUserRole("EvBooking_DistributionChannels_Delete")
        }

        this.disableNode(this.btnNew, !this.crud.hasCreate);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DistributionChannelList);